// Module
var code = "<h1 id=\"reports\">Reports</h1> <p>After terms have been successfully set up in Admin&gt;Campus, Reports can be created in the reports tab for specific or multiple terms and semesters.</p> <p>Each report block is further divided into tabs to manage the process and help define report blocks per phase or per campus.</p> ";
// Exports
module.exports = code;